// Rango de ensacado del formulador web.
// Alisur y Colun leen el mínimo desde Ajustes de Alisur.
// Coagra mantiene el mínimo histórico de 5 toneladas, sin recargo por peso.

const FORMULATOR_MAX_ORDER_TONS = 15;
const DEFAULT_MIN_ORDER_TONS = 5;
const PELLET_FORMS = ['pellet12', 'pellet8', 'pellet6', 'pellet3'];
const BAGGED_POWDER_DENSITY_MESSAGE = 'Para poder ensacar esta fórmula se requiere aumentar su densidad. Prueba con otra fórmula';

function packagingValue(packaging) {
  if (!packaging) return '';
  if (typeof packaging === 'string') return packaging;

  return packaging.value || '';
}

function isBaggedPackaging(packaging) {
  const value = packagingValue(packaging);

  return value === 'bagged25' || value.startsWith('bagged25_');
}

function baggedAllowsForm(form) {
  return form === 'powder' || PELLET_FORMS.includes(form);
}

function formulatorFormValues({ packaging, includeMultiparticle = false } = {}) {
  const bulkOnly = ['powder'];
  if (includeMultiparticle) bulkOnly.push('multiparticle');
  if (isBaggedPackaging(packaging)) return ['powder'].concat(PELLET_FORMS);

  return bulkOnly.concat(PELLET_FORMS);
}

function formulaDensity(proportions, ingredientsByName) {
  return Object.keys(proportions || {}).reduce((total, name) => {
    const percentage = parseFloat(proportions[name]) || 0;
    const ingredient = ingredientsByName && ingredientsByName[name];
    const density = ingredient ? parseFloat(ingredient.powder_density) || 0 : 0;

    return total + (percentage / 100) * density;
  }, 0);
}

function baggedPowderDensityBlocked({
  form, packaging, minDensity, proportions, ingredientsByName,
} = {}) {
  if (form !== 'powder' || !isBaggedPackaging(packaging)) return false;

  const minimum = parseFloat(minDensity);
  if (!Number.isFinite(minimum) || minimum <= 0) return false;

  return formulaDensity(proportions, ingredientsByName) < minimum;
}

function formulatorBaggedMinTons({ isCoagraWeb = false, minimumOrderTons } = {}) {
  if (isCoagraWeb) return DEFAULT_MIN_ORDER_TONS;

  const configured = Number(minimumOrderTons);
  const inRange = Number.isInteger(configured)
    && configured >= 1
    && configured <= FORMULATOR_MAX_ORDER_TONS;
  if (inRange) return configured;

  return DEFAULT_MIN_ORDER_TONS;
}

function baggedPackagingOptions(minTons) {
  const options = [];
  for (let tons = minTons; tons <= FORMULATOR_MAX_ORDER_TONS; tons += 1) {
    options.push({
      value: `bagged25_${tons}ton`,
      weight: tons,
      label: `Ensacado 25 kg (${tons} tons)`,
      shortLabel: 'Ensacado 25 kg',
    });
  }

  return options;
}

function tonsFromBaggedPackaging(value, totalSackWeight) {
  if (value === 'bagged25_05ton') return 0.5;
  if (value === 'bagged25_075ton') return 0.75;

  const match = String(value || '').match(/^bagged25_(\d+)ton$/);
  if (match) return Number(match[1]);

  const tons = Number(String(totalSackWeight ?? '').replace(',', '.'));
  if (Number.isFinite(tons) && tons > 0) return tons;

  return null;
}

function baggedValueForTons(tons) {
  if (tons === 0.5) return 'bagged25_05ton';
  if (tons === 0.75) return 'bagged25_075ton';

  return `bagged25_${tons}ton`;
}

// En el resumen del pedido el peso va en su propia línea.
// El envase no repite las toneladas.
function packagingSummaryLabel(packaging) {
  const value = packagingValue(packaging);
  if (value.indexOf('bagged25') === 0) return 'Ensacado 25 kg';
  if (value === 'bulk') return 'Granel';
  if (value === 'maxibag') return 'Maxisaco';

  const raw = packaging && typeof packaging === 'object'
    ? (packaging.shortLabel || packaging.label || '')
    : '';

  return String(raw).replace(/\s*\([^)]*\)\s*$/, '');
}

function resolveOrderPackaging(packaging, totalSackWeight, formulatorOptions, productOptions) {
  const value = packagingValue(packaging);
  const fromFormulator = (formulatorOptions || []).find(option => option.value === value);
  if (fromFormulator) return fromFormulator;

  const fromProduct = (productOptions || []).find(option => option.value === value);
  if (fromProduct) return fromProduct;

  if (value === 'bagged25' || value.startsWith('bagged25_')) {
    const tons = tonsFromBaggedPackaging(value, totalSackWeight);
    const resolvedValue = value === 'bagged25' && tons ? baggedValueForTons(tons) : value;

    return {
      value: resolvedValue,
      weight: tons,
      label: 'Ensacado 25 kg',
      shortLabel: 'Ensacado 25 kg',
    };
  }

  if (!value) return null;

  const label = packagingSummaryLabel(value);

  return { value, label, shortLabel: label };
}

module.exports = {
  FORMULATOR_MAX_ORDER_TONS,
  DEFAULT_MIN_ORDER_TONS,
  BAGGED_POWDER_DENSITY_MESSAGE,
  formulatorBaggedMinTons,
  baggedPackagingOptions,
  packagingSummaryLabel,
  resolveOrderPackaging,
  baggedAllowsForm,
  formulatorFormValues,
  formulaDensity,
  baggedPowderDensityBlocked,
};
